import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable()
export class RequestHandlingInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        if (request.url.startsWith('/api/')) {
            request = request.clone(
                {
                    url: request.url.replace('/api/', `${environment.backendURL}`),
                    // withCredentials: true
                }
            );
        }
        return next.handle(request);
    }

}